// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Link = require("next/link").default;
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");

function PropertySearchResultTitle(props) {
  let children = props.children;
  let detailsHref = props.detailsHref;
  let className = TailwindMerge.twMerge([
    "text-zinc-700 text-lg font-medium leading-tight",
    Stdlib_Option.getOr(props.className, "")
  ]);
  return JsxRuntime.jsx("h3", {
    children: detailsHref !== undefined ? JsxRuntime.jsx(Link, {
        href: detailsHref,
        className: "relative z-30 hover:text-zinc-900 hover:underline focus:underline",
        children: children
      }) : children,
    className: className
  });
}

let make = PropertySearchResultTitle;

exports.make = make;
/* next/link Not a pure module */
